import React from 'react';
import ChallengerModal from './ChallengerModal';

const FighterModalNew = ({ isOpen, onClose, selectedIcon, fighterName, fighterUsername }) => {
  return (
    <ChallengerModal
      isOpen={isOpen}
      onClose={onClose}
      icon={<img src={selectedIcon} alt='fighter_icon' />}
      heading='You Selected:'
      boldText={fighterName}
      subText={`@${fighterUsername}`}
    />
  );
};

export default FighterModalNew;
